<div class="row" *ngIf="isLoading">
  <div class="col-md-8 col-sm-12">
    <img class="load-img" src="{{constants.TIPSJAR_LOAD1_IMG}}" alt="">
    <img class="load-img" src="{{constants.TIPSJAR_LOAD2_IMG}}" alt="">
  </div>
  <div class="col-md-4 col-sm-12">
    <img class="load-img" src="{{constants.TIPSJAR_LOAD3_IMG}}" alt="">
  </div>
</div>
<div class="row" *ngIf="!isLoading && showTips">
  <div class="col-md-8 col-sm-12 ">
    <div class="w-100 bg-white header">
      <div class="row  header-div">
        <div class="col-6">
          <div class="header-div-title-1">{{constants.Total_Tips_TXT}}</div>
          <div class="header-div-title-2">{{totalAmount | currency }}
            <!-- <span (click)="onClickOpenFeeInfo()"
              class="fee-info">(After
              WS
              Fees)</span> -->
            </div>
        </div>
        <div class="col-6" style="padding-left: 10px;">
          <div class="header-div-title-1">{{constants.Number_OF_Tipers_TXT}}</div>
          <div class="header-div-title-2">{{PaymentCount}}</div>
        </div>
      </div>
    </div>
    <div class="w-100 bg-white main header" *ngIf="!nonHasTipped">
      <div *ngFor="let item of this.paymentList">
        <div class="row message-row" *ngIf="item.usersName !== undefined">
          <div class="col-6 message-col">
            <div class="main-text-1">
              <span class="main-text-1-title">{{item.usersName}}</span>
              {{constants.sending_TXT}} <span class="main-text-1-title">{{item.amountPaid | currency}}</span>
            </div>
          </div>
          <div class="col-6 message-col">
            <div class="main-text-2-title">{{item.messageOfUser}}</div>
          </div>
          <hr>
        </div>
      </div>
    </div>

    <div class="w-100 bg-white main-1 header" *ngIf="nonHasTipped">
      <div class="no-tip-title">No Tips yet.</div>
      <div class="no-tip-title-1">The more window views you submit</div>
      <div class="no-tip-title-1">the more likely you are to get tipped!</div>
    </div>
  </div>
  <div class=" col-md-4 d-sm-none d-xs-none d-none d-md-block " *ngIf=" !isKYCRequired">
    <div class="w-100 bg-white h-100 header ">
      <div class="p-3 payment-settings">PAYMENT SETTINGS</div>
      <div class="btn-tips ">
        <label class="switch">
          <input [disabled]="isProcessing" [checked]="checked" (change)="onclickreceivePayment($event)" type="checkbox">
          <span class="slider round"> </span>
        </label>
      </div>
      <p *ngIf="checked" class="status">People can now send you Tips to thank you.</p>
      <p *ngIf="!checked" class="status">You are not accepting tips at this point,</p>
      <hr class="break">
      <div class="stripe-conneced">
        <div style="width: 80%;">
          <div class="connect-stripe">Connected to Stripe</div>
          <div class="btn-tips-1"><button class="tip"><a href="https://dashboard.stripe.com/login" target="_blank">Go to
                Stripe</a></button></div>
        </div>
        <div><button class="s-image"><img [src]="constants.S_IMG" class="s-image-1" /></button></div>
        <div>
        </div>
      </div>
    </div>
  </div>

  <div class=" col-md-4 d-sm-none d-xs-none d-none d-md-block " *ngIf="isKYCRequired">
    <div class="w-100 bg-white h-100 header ">
      <div class="p-3 payment-settings">PAYMENT SETTINGS</div>
      <div class="btn-tips ">
        <label class="switch">
          <input disabled [checked]="false" type="checkbox">
          <span class="slider round"> </span>
        </label>
      </div>
      <div class="p-3 kyc-notice">
        <div>
          <span><b>IMPORTANT:</b> To keep your Tip Jar active, please update your account details on Stripe.</span>
        </div>
        <div class="mt-3">
          <button (click)="onClickReAuth()" [disabled]="isProcessing" class="kyc-btn">Update on Stripe</button>
        </div>
      </div>
    </div>
  </div>

</div>
<div class="div-class" *ngIf="dropdown && !isLoading">
  <div><img [src]="constants.TIPS_BLURB_IMG" class="select-country-with-tip"></div>
  <div class="content">
    <div class="page-1-text">Now your window views
      can make you some money!</div>
    <div class="page-1-content">Just complete a few easy steps below to set up your tips jar securely and start
      receiving tips.
    </div>
    <div class="btn-group dropup">
      <button type="button"
        class="btn dropdown-toggle bg-white countries d-flex justify-content-between aliDiv2gn-items-center"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <div><span class="coutry-list">select your country</span></div>
        <div><i class="fa fa-angle-up" aria-hidden="true"></i>
        </div>
      </button>
      <div class="dropdown-menu  list-group-flush" id="Div1">
        <li class="list-group-item list-item"><input class="search" type="text" placeholder="search"
            (keyup)="search($event)"></li>
        <li class="list-group-item list-item" id="Div2" *ngFor="let country of countryList"
          (click)="selectCountry(country)"><input name="{{country['countryCode']}}" value="{{country['countryName']}}"
            type="Submit" /></li>
      </div>
    </div>
  </div>
</div>
<div *ngIf="dropdown && !isLoading" class="query">
  <a [routerLink]="['/blog/tipjar']" class="whytips" target="_blank"><b>Why a Tip Jar?</b></a>
    <p>Questions? Email us at <a href="mailto:{{ emailAddress }}" target="_blank"><b>{{ emailAddress }}</b></a>.</p>
</div>

<div class="d-flex justify-content-center align-items-center flex-column bg-white connect-div"
  *ngIf="connectpage &&!isLoading">
  <div>
    <img [src]="constants.S_IMG" class="connect-img" />
  </div>
  <div class="connect-title">
    Now let's set up your Tip Jar!
  </div>
  <div class="connect-text">
    Create or connect your secure payment account with <br>
    Stripe to start receiving tips. <br>
    Stripe accepts credit cards, Apple pay and Google pay.
  </div>
  <div class="connect-text">The money you make is paid out directly to your bank.</div>
  <div class="btn-tips-1">
    <button *ngIf="!reauth" (click)="onClickConnectToStripe()" class="connect-btn" [disabled]="isProcessing">Connect to
      Stripe</button>
    <button *ngIf="reauth" (click)="onClickReAuth()" class="connect-btn" [disabled]="isProcessing">Complete stripe
      connect</button>
  </div>
  <p *ngIf="reauth" class="incomplete">Oops! Your connection to Stripe could not be <br> completed. The details you’ve
    provided are either<br> incorrect or incomplete.</p>
</div>
<div *ngIf="connectpage &&!isLoading" class="query-connect">
  <a [routerLink]="['/blog/tipjar']" class="whytips" target="_blank"><b>Why a Tip Jar?</b></a>
  <p>Questions? Email us at <a href="mailto:{{ emailAddress }}" target="_blank"><b>{{ emailAddress }}</b></a>.
  </p>
</div>
<div class="d-flex justify-content-center align-items-center flex-column connect-div"
  *ngIf="showNotEligible && !isLoading">
  <div class="sry-text">Oops, this feature is not<br> supported in your country.</div>
  <div><img [src]="constants.TIPS_BLURB_IMG" class="sry-img"></div>
  <div class="sry-btn text-center" (click)="showDropdown()">
    < Back </div>
  </div>
  <div id="popup" class="fee-info-popup-background" (click)="onClickCloseFeeInfo()">
    <div class="fee-info-popup-backdrop">
      <h1 class="fee-info-title">{{constants.ENTIRE_AMOUNT_YOURS}}</h1>
      <p class="fee-info-body">{{constants.ENTIRE_AMOUNT_YOURS_10PERCENT_INTREST}}</p>
      <p class="fee-info-body">{{constants.ENTIRE_AMOUNT_YOURS_TIPJAR_THANKS}}</p>
    </div>
  </div>